{
    "CxiLicenceType_SOLO": "Solo",
    "CxiLicenceType_TEAMS": "Teams",
    "CxiLicenceType_CXI": "Integração CX",
    "CxiLicenceType_NONE": "Nenhum",
    "NAME": "CxiLicenceTypes"
}